/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
// Recovered stub: production builds eliminated this module because debugLog is a
// no-op in production. Logs only outside production, for local debugging.
export const debugLog = (...args) => {
  try {
    if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  } catch (e) {
    /* ignore */
  }
};
